export default "__VITE_ASSET__CsZgNxT$__"